import { render, staticRenderFns } from "./StartForm.vue?vue&type=template&id=1a6421a1"
import script from "./StartForm.vue?vue&type=script&lang=js"
export * from "./StartForm.vue?vue&type=script&lang=js"
import style0 from "./StartForm.vue?vue&type=style&index=0&id=1a6421a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports